import * as React from 'react';

import { FavoriteButtonMobile } from '../../components/FavoriteButton';
import { useFavoriteButton } from './hooks/useFavoriteButton';

export const FavoriteButtonMobileContainer: React.VFC = () => {
  const { isFavorite, handleClickFavorite } = useFavoriteButton();

  return <FavoriteButtonMobile isFavorite={isFavorite} onClick={handleClickFavorite} />;
};
